export const licenseKey =
    'ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogIjVlZDdjNzlhLTFmOGUtNDg5MS04OTUzLWQ4MGM0MDhkZmFhMCIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjUxCn0=.N1npXTjgHq5j7GKwT7yJ/TehuGFRlBYC1gHNOQKAZvBc3nLPI24dkcSUVsV2YeIz7n6Z/FHhdNAVtbNxUl/25g5d6h1FC2/kSD65/OsLrdKEaXmobGCB2b3CHhPqJD4hHLcJug==';
